var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlFluvialGlobalFathom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    viewBox: "0 0 24 24",
    width: "100%",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.773 18.233c-1.032-.393-2.119-.733-3.69-.733-2.475 0-4.17.316-5.083.948v2.538c1.01-.632 2.725-.948 5.149-.948 1.56 0 2.74.361 3.851.774v-2.491l-.227-.088ZM11 16.279c-1.073-.4-2.246-.743-3.851-.743-2.559 0-4.275.316-5.149.947v-2.536c.742-.513 2-.818 3.774-.914l.001-1.102h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.106-.106L11.14 2l3.04 3.245V3.968c0-.474.506-.71 1.52-.71.944 0 1.463.206 1.555.618l.013.092v4.344l.997.935c.49.362.734.85.734 1.465 0 .101-.004.198-.013.288H11v1.323h-.474a1 1 0 0 0-.993.883l-.004.104c.522.137 1 .306 1.471.484v2.485Zm5.493-.466v.894h1.633v.71h-1.633v1.566h-.817v-3.897h2.877v.726h-2.06ZM22 22V12H12v10h10Zm-9-9h8v8h-8v-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlFluvialGlobalFathom);
export default __webpack_public_path__ + "static/media/fl_fluvial_global_fathom.714d002aa93ca90256d638bbb49d5b24.svg";
export { ForwardRef as ReactComponent };